module.exports = __webpack_public_path__ + "img/occupy1.af993ae5.png";